import React, { useMemo } from 'react';

const SeasonRunDiff = ({ standings }) => {
  const teams = useMemo(() => {
    if (!standings?.length) return [];
    return [...standings].sort((a, b) => {
      const rdA = (a.runsScored ?? 0) - (a.runsAllowed ?? 0);
      const rdB = (b.runsScored ?? 0) - (b.runsAllowed ?? 0);
      return rdB - rdA;
    });
  }, [standings]);

  const maxAbs = useMemo(() => {
    return Math.max(...teams.map(t => Math.abs((t.runsScored ?? 0) - (t.runsAllowed ?? 0))), 1);
  }, [teams]);

  if (!teams.length) return null;

  return (
    <div className="border border-[#658d71] bg-[rgba(0,0,0,0.08)]">
      <div className="px-3 py-2 border-b border-[#658d71] bg-[rgba(0,0,0,0.1)]">
        <span className="text-xs font-black uppercase tracking-widest text-[#d8ceb3]">AL East Run Differential</span>
      </div>
      <div className="p-3 flex flex-col gap-2">
        {teams.map(t => {
          const rs = t.runsScored ?? 0;
          const ra = t.runsAllowed ?? 0;
          const rd = rs - ra;
          const isSOX = t.team?.id === 111;
          const pct = Math.abs(rd) / maxAbs;
          const isPos = rd >= 0;
          return (
            <div key={t.team?.id} className={`flex items-center gap-2 py-1 ${isSOX ? 'bg-[rgba(216,206,179,0.05)] px-1' : ''}`}>
              <span className={`text-[10px] font-black uppercase tracking-widest w-8 shrink-0 ${isSOX ? 'text-[#d8ceb3]' : 'text-[#a9c9b1]'}`}>
                {t.team?.abbreviation ?? '--'}
              </span>
              <div className="flex-1 flex items-center gap-1">
                <div className="flex-1 flex justify-end">
                  {!isPos && (
                    <div className="h-3 rounded-l-sm" style={{ width: `${pct * 100}%`, backgroundColor: '#c4333e', opacity: 0.7 }} />
                  )}
                </div>
                <span className={`text-[10px] font-black tabular-nums w-10 text-center shrink-0 ${isPos ? 'text-[#a9c9b1]' : 'text-[#c4333e]'}`}>
                  {rd > 0 ? `+${rd}` : rd}
                </span>
                <div className="flex-1">
                  {isPos && (
                    <div className="h-3 rounded-r-sm" style={{ width: `${pct * 100}%`, backgroundColor: '#658d71', opacity: 0.8 }} />
                  )}
                </div>
              </div>
              <span className="text-[9px] text-[#658d71] tabular-nums w-16 text-right shrink-0 font-bold">
                {rs}R / {ra}RA
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SeasonRunDiff;